// extracted by mini-css-extract-plugin
module.exports = {"container":"GrayBackground_container__4BuJE","wrapper":"GrayBackground_wrapper__364L9","title":"GrayBackground_title__2S2fK"};